var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,1.39534884 C5.24778239,1.39534884 1.39534884,5.24778239 1.39534884,10 C1.39534884,14.7522176 5.24778239,18.6046512 10,18.6046512 C14.7522176,18.6046512 18.6046512,14.7522176 18.6046512,10 C18.6046512,5.24778239 14.7522176,1.39534884 10,1.39534884 Z M12.5286188,13.6743435 C12.9139338,13.6743435 13.2262933,13.986703 13.2262933,14.3720179 C13.2262933,14.7573329 12.9139338,15.0696924 12.5286188,15.0696924 L6.94722349,15.0696924 C6.56190855,15.0696924 6.24954907,14.7573329 6.24954907,14.3720179 C6.24954907,13.986703 6.56190855,13.6743435 6.94722349,13.6743435 L12.5286188,13.6743435 Z M5.81395349,6.27906977 C6.58458337,6.27906977 7.20930233,6.90378872 7.20930233,7.6744186 C7.20930233,8.44504849 6.58458337,9.06976744 5.81395349,9.06976744 C5.0433236,9.06976744 4.41860465,8.44504849 4.41860465,7.6744186 C4.41860465,6.90378872 5.0433236,6.27906977 5.81395349,6.27906977 Z M14.1860465,6.27906977 C14.9566764,6.27906977 15.5813953,6.90378872 15.5813953,7.6744186 C15.5813953,8.44504849 14.9566764,9.06976744 14.1860465,9.06976744 C13.4154166,9.06976744 12.7906977,8.44504849 12.7906977,7.6744186 C12.7906977,6.90378872 13.4154166,6.27906977 14.1860465,6.27906977 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeh);
export default __webpack_public_path__ + "static/media/meh.f5ff9fc87ee962f96c42fc3723593f14.svg";
export { ForwardRef as ReactComponent };